import InvestorLogin from './InvestorLogin';

export default InvestorLogin;
